import { render } from "./SectionWrapper.vue?vue&type=template&id=648ec902"
import script from "./SectionWrapper.vue?vue&type=script&lang=ts"
export * from "./SectionWrapper.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBar,QCardSection});
